import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';

export const updateContributorSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    name: z.string().min(2, t('contributor.validation.nameMinLength')),
    role: z.string().nonempty(t('contributor.validation.roleRequired')),
    position: z.string().optional(),
    organization: z.string().optional(),
    email: z.string().refine((val) => val === '' || z.string().email().safeParse(val).success, {
      message: t('contributor.validation.emailInvalid'),
    }),
  });
};
